import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { startBuyingPlan } from "../actions/plans";
import { formatSubs } from "../utils/array";
import done from "../images/ic_done.svg";
import cross from "../images/ic_cross.svg";
import "../styles/components/verify-email.scss";
import { startGettingSubscriptions } from "../actions/plans";
import { store } from "../store/configureStore";

class PayVerif extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: undefined,
      code: undefined,
      amount: undefined,
      planName: undefined,
      goal: undefined,
    };
  }
  componentDidMount() {
    store.dispatch(startGettingSubscriptions);
    const params = new URLSearchParams(this.props.location.search);
    const pathName = this.props.location.pathname;
    const status = params.get("status");
    const code = params.get("code");
    const amount = params.get("amount");
    const planName = params.get("plan_name");
    const period = params.get("period");
    const goal = params.get("goal");

    if (String(this.state.status).toLocaleLowerCase() === "ok") {
      if (pathName === "/zarinpal_transaction_result") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "purchase",
          ecommerce: {
            transaction_id: code,
            value: parseFloat(amount),
            currency: "TRY",
            items: [
              {
                item_name: "Wallet Deposit",
                index: 0,
                price: parseFloat(amount),
                quantity: 1,
              },
            ],
          },
        });
      }
      if (goal === "buy_plan") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "service",
          service_name: "Upgrade Plan",
          plan_price: parseFloat(amount),
          package_type: planName,
          package_variant: period,
        });
      }
    }

    if (
      planName &&
      goal === "buy_plan" &&
      pathName === "/zarinpal_transaction_result" &&
      !this.props.subscriptions.includes(planName)
    ) {
      this.props.startBuyingPlan(planName, period);
    }

    this.setState(() => ({
      status,
      code,
      amount,
      planName,
      goal,
      period,
    }));
  }

  render() {
    const ok = this.state.status === "OK";
    return (
      <div className="verify-container">
        <div className="verify-card">
          <div className="verif-header">
            <img src={ok ? done : cross} className="ic-state-pay" alt="done" />
            <div className="verif-info">
              {ok ? (
                <>
                  {this.state.code ? (
                    <h2>
                      Transaction ID: <span>{this.state.code}</span>
                    </h2>
                  ) : undefined}
                  {this.state.amount ? (
                    <h2>
                      Amount: <span>{`${this.state.amount} Tomans`}</span>
                    </h2>
                  ) : undefined}
                  {this.state.planName ? <h2>{`Plan ${this.state.planName} activated!`}</h2> : undefined}
                </>
              ) : (
                <h2>Transaction Failed!</h2>
              )}
            </div>
          </div>

          <Link to="/" className="button-login">
            Back to home
          </Link>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  subscriptions: formatSubs(state.plans.subscriptions, "name") || [],
});

const mapDispatchToProps = (dispatch) => ({
  startBuyingPlan: (plan_name, period) => dispatch(startBuyingPlan(plan_name, period)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayVerif);
